<template>
	<carousel
		:scrollPerPage="true"
		:perPageCustom="[
			[480, 2],
			[768, 3],
			[1024, 4],
		]"
	>
		<slide v-for="(img, index) in images" :key="index + 10">
			
			<b-col  class="h-100 d-flex flex-column">
				
				<b-img
					v-img
					:src="img.source"
					fluid-grow
					:alt="img.fileName"
				></b-img>
				
				<b-button title="Add to editor" variant="outline-primary" squared block @click.prevent="select(img)" class="mt-auto">
					<b-icon font-scale="1.5" icon="box-arrow-in-down-right"></b-icon>
				</b-button>

			</b-col>
		</slide>
	</carousel>
</template>

<script>
import ClockService from "@/api-services/clock.service";
import FileService from "@/api-services/file.service";

import { Carousel, Slide } from "vue-carousel";

export default {
	name: "ImagePicker",

	// things we have inherited from our parent
	props: ["clockId"],

	components: {
		Carousel,
		Slide,
	},

	// data we bind to, components need a function wrapping this all up, to keep instances seperate
	data: function () {
		return {
			images: [],
		};
	},

	computed: {},

	created() {
		this.fetchAssets();
	},

	// things we do to data
	methods: {
		select(_img) {
			this.$emit("select", _img);
		},

		fetchAssets() {
			ClockService.getAssets(this.clockId).then((res) => {
				let filteredAssets = res.data.filter((asset) => {
					return asset.AssetType == 1;
				});

				filteredAssets.forEach((asset) => {
					this.streamToBase64(asset);
				});
			});
		},

		streamToBase64(_asset) {
			FileService.getStream(_asset.NanId)
				.then((res) => {
					let assetLink = {
						guid: _asset.NanId,
						fileName: _asset.FileName,
						contentType: _asset.ContentType,
						source: this.imageEncode(res.data),
					};
					this.images.push(assetLink);
				})
				.catch((error) => {
					console.log(error);
				});
		},

		// put the stream into a base64 encoded string ready for the src of the img element.
		imageEncode(arrayBuffer) {
			let b64encoded = btoa(
				[].reduce.call(
					new Uint8Array(arrayBuffer),
					function (p, c) {
						return p + String.fromCharCode(c);
					},
					""
				)
			);
			let mimetype = "image/jpeg";
			return "data:" + mimetype + ";base64," + b64encoded;
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/partials/quote-images.vue